var P = Object.defineProperty;
var A = (o, e, t) => e in o ? P(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var s = (o, e, t) => A(o, typeof e != "symbol" ? e + "" : e, t);
import { defineStore as F } from "pinia";
import { defineComponent as I, resolveComponent as S, openBlock as k, createBlock as y, unref as l, withCtx as w, createVNode as v, createElementVNode as h, toDisplayString as E, createElementBlock as q, Fragment as V, renderList as L, normalizeClass as W, createTextVNode as B } from "vue";
class u {
  constructor() {
    s(this, "callbackList");
    this.callbackList = [];
  }
  AddCallback(e) {
    this.callbackList.push(e);
  }
  RemoveCallback(e) {
    this.callbackList.forEach((t, n) => {
      t === e && this.callbackList.splice(n, 1);
    });
  }
  ClearCallbacks() {
    this.callbackList = [];
  }
  CallbackCount() {
    return this.callbackList.length;
  }
  // Transport notifications must not let one consumer interrupt other listeners.
  ExecuteSafely(...e) {
    for (const t of [...this.callbackList])
      try {
        const n = t.call(t, e);
        n && typeof n.then == "function" && Promise.resolve(n).catch((i) => console.error(i));
      } catch (n) {
        console.error(n);
      }
  }
  Execute(...e) {
    this.callbackList.forEach((t) => {
      t.call(t, e);
    });
  }
}
class U {
  constructor() {
    s(this, "OnMessageReceived");
    s(this, "OnRequestFailed");
    s(this, "requestPath", "/appinvoke");
    s(this, "httpRequest");
    s(this, "makeRequest", (e) => {
      this.httpRequest.open("POST", this.requestPath, !0), this.httpRequest.setRequestHeader("Content-type", "application/json"), this.httpRequest.send(e);
    });
    s(this, "makeUpload", (e) => {
      this.httpRequest.open("POST", this.requestPath, !0), this.httpRequest.send(e);
    });
    s(this, "abort", () => this.httpRequest.abort());
    s(this, "processError", () => this.OnRequestFailed.Execute("NETWORK_ERROR"));
    s(this, "processRequest", (e) => {
      this.httpRequest.status === 200 ? this.OnMessageReceived.Execute(this.httpRequest.responseText) : this.OnRequestFailed.Execute(`HTTP_${this.httpRequest.status}`);
    });
    this.OnMessageReceived = new u(), this.OnRequestFailed = new u(), this.httpRequest = new XMLHttpRequest(), this.httpRequest.onerror = this.processError, this.httpRequest.onload = this.processRequest, this.httpRequest.ontimeout = () => this.OnRequestFailed.Execute("REQUEST_TIMEOUT"), this.httpRequest.onabort = () => this.OnRequestFailed.Execute("REQUEST_ABORTED");
  }
}
class j {
  constructor() {
    s(this, "OnSocketConnected", new u());
    s(this, "OnAuthenticationFailed", new u());
    s(this, "OnMessageReceived", new u());
    s(this, "OnSocketDisconnected", new u());
    s(this, "OnSocketError", new u());
    s(this, "isConnected", !1);
    s(this, "shouldReconnect", !0);
    s(this, "requestPath");
    s(this, "socket", null);
    s(this, "connectionPromise", null);
    s(this, "resolveConnection", null);
    s(this, "rejectConnection", null);
    s(this, "pingInterval", 5e3);
    // Allow a 30s receive-loop reply and a 30s PONG send, plus network slack.
    // Keep aligned with WebSocketWriter's send deadline.
    s(this, "pongInterval", 75e3);
    s(this, "connectionTimeoutMs", 15e3);
    s(this, "connectionTimeoutHandle", null);
    s(this, "pingHandle", null);
    s(this, "pongHandle", null);
    s(this, "reconnectHandle", null);
    s(this, "connectSocket", () => {
      var t;
      if (this.shouldReconnect = !0, this.connectionPromise) return this.connectionPromise;
      if (this.isConnected && ((t = this.socket) == null ? void 0 : t.readyState) === WebSocket.OPEN) return Promise.resolve();
      if (this.clearReconnect(), this.socket) {
        if (this.closeCurrentSocket(new Error("WebSocket connection closed.")), this.connectionPromise) return this.connectionPromise;
        if (!this.shouldReconnect) return Promise.reject(new Error("WebSocket connection cancelled."));
        this.clearReconnect();
      }
      const e = new Promise((n, i) => {
        this.resolveConnection = n, this.rejectConnection = i;
      });
      this.connectionPromise = e;
      try {
        const n = new WebSocket(this.requestPath);
        this.socket = n, this.connectionTimeoutHandle = window.setTimeout(() => {
          this.socket !== n || this.connectionPromise !== e || this.closeCurrentSocket(new Error("WebSocket connection timed out."));
        }, this.connectionTimeoutMs), n.onopen = () => {
          this.socket === n && (this.isConnected = !0, this.connectionPing(), this.socket === n && (this.settleConnection(), this.OnSocketConnected.ExecuteSafely()));
        }, n.onclose = () => {
          this.socket === n && this.closeCurrentSocket(new Error("WebSocket connection closed."));
        }, n.onerror = () => {
          this.socket === n && this.closeCurrentSocket(new Error("WebSocket connection failed."));
        }, n.onmessage = (i) => {
          this.socket === n && this.socketMessageReceived(i);
        };
      } catch (n) {
        this.closeCurrentSocket(n);
      }
      return e;
    });
    s(this, "settleConnection", (e) => {
      this.connectionTimeoutHandle !== null && window.clearTimeout(this.connectionTimeoutHandle), this.connectionTimeoutHandle = null;
      const t = this.resolveConnection, n = this.rejectConnection;
      this.connectionPromise = null, this.resolveConnection = null, this.rejectConnection = null, e === void 0 ? t == null || t() : n == null || n(e);
    });
    s(this, "clearReconnect", () => {
      this.reconnectHandle !== null && window.clearTimeout(this.reconnectHandle), this.reconnectHandle = null;
    });
    s(this, "clearHeartbeat", () => {
      this.pingHandle !== null && window.clearTimeout(this.pingHandle), this.pongHandle !== null && window.clearTimeout(this.pongHandle), this.pingHandle = null, this.pongHandle = null;
    });
    s(this, "doReconnect", () => {
      if (!this.shouldReconnect || this.reconnectHandle !== null) return;
      const e = window.setTimeout(() => {
        this.reconnectHandle !== e || !this.shouldReconnect || (this.reconnectHandle = null, this.connectSocket().catch(() => {
        }));
      }, 3e3 + Math.round(Math.random() * 5e3));
      this.reconnectHandle = e;
    });
    s(this, "closeCurrentSocket", (e) => {
      const t = this.socket, n = t !== null || this.connectionPromise !== null;
      this.socket = null, this.isConnected = !1, this.clearHeartbeat(), this.settleConnection(e), t && (t.onopen = null, t.onclose = null, t.onerror = null, t.onmessage = null, (t.readyState === WebSocket.OPEN || t.readyState === WebSocket.CONNECTING) && t.close()), this.doReconnect(), n && this.OnSocketDisconnected.ExecuteSafely();
    });
    s(this, "disconnectSocket", () => {
      this.shouldReconnect = !1, this.clearReconnect(), this.closeCurrentSocket(new Error("WebSocket connection cancelled."));
    });
    s(this, "sendMessage", (e) => {
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN)
        throw new Error("WebSocket is not open.");
      this.socket.send(e);
    });
    s(this, "socketMessageReceived", (e) => {
      const t = this.socket;
      if (this.pingHandle !== null && window.clearTimeout(this.pingHandle), this.pingHandle = null, e.data === "AUTHTOKEN_INVALID" || e.data === "AUTH_FAILED") {
        this.shouldReconnect = !1, this.isConnected = !1;
        try {
          this.OnAuthenticationFailed.ExecuteSafely();
        } finally {
          this.socket === t && this.disconnectSocket();
        }
        return;
      }
      try {
        e.data === "PONG" ? (this.pongHandle !== null && window.clearTimeout(this.pongHandle), this.pongHandle = null) : this.OnMessageReceived.ExecuteSafely(e.data);
      } finally {
        if (this.socket === t && this.isConnected) {
          const n = window.setTimeout(() => {
            this.socket !== t || this.pingHandle !== n || (this.pingHandle = null, this.connectionPing());
          }, this.pingInterval);
          this.pingHandle = n;
        }
      }
    });
    s(this, "connectionPing", () => {
      if (!this.isConnected || !this.socket || (this.pingHandle !== null && window.clearTimeout(this.pingHandle), this.pingHandle = null, this.pongHandle !== null)) return;
      const e = this.socket, t = window.setTimeout(() => {
        this.socket !== e || this.pongHandle !== t || this.connectionPongMissed();
      }, this.pongInterval);
      this.pongHandle = t;
      try {
        this.sendMessage("PING");
      } catch (n) {
        this.closeCurrentSocket(n);
      }
    });
    s(this, "connectionPongMissed", () => {
      !this.isConnected || !this.socket || this.pongHandle === null || this.closeCurrentSocket(new Error("WebSocket heartbeat timed out."));
    });
    const e = window.location, t = e.protocol === "http:" ? "ws" : "wss";
    this.requestPath = `${t}://${e.host}/ws`;
  }
}
let T = (o) => o;
function te(o) {
  T = o;
}
function p(o, ...e) {
  return T(o, ...e);
}
const x = /* @__PURE__ */ new WeakMap();
function m(o) {
  const e = o.$state;
  let t = x.get(e);
  return t || (t = { messages: [], documentVersion: 0 }, x.set(e, t)), t;
}
function D(o) {
  const e = m(o).messages[0];
  e && (o.MessageBox = { ...e.message, Display: !0 });
}
function C(o) {
  const e = m(o), t = e.resolveDocument;
  e.resolveDocument = void 0, e.documentVersion++, t == null || t();
}
var O = /* @__PURE__ */ ((o) => (o[o.OK = 0] = "OK", o[o.Cancel = 1] = "Cancel", o[o.Yes = 2] = "Yes", o[o.No = 3] = "No", o[o.Close = 4] = "Close", o))(O || {});
const M = {
  0: {
    Id: "OK",
    CaptionKey: "fw4.MessageBox.Buttons.OK",
    Type: 0,
    IsPrimary: !0
  },
  1: {
    Id: "Cancel",
    CaptionKey: "fw4.MessageBox.Buttons.Cancel",
    Type: 1,
    IsPrimary: !1
  },
  2: {
    Id: "Yes",
    CaptionKey: "fw4.MessageBox.Buttons.Yes",
    Type: 2,
    IsPrimary: !0
  },
  3: {
    Id: "No",
    CaptionKey: "fw4.MessageBox.Buttons.No",
    Type: 3,
    IsPrimary: !1
  },
  4: {
    Id: "Close",
    CaptionKey: "fw4.MessageBox.Buttons.Close",
    Type: 4,
    IsPrimary: !1
  }
}, g = F("fw4Store", {
  state: () => ({
    MessageBox: {
      Title: "",
      Content: "",
      Display: !1,
      ButtonList: []
    },
    DocumentViewer: {
      Title: "",
      Url: "",
      Display: !1
    },
    ExportFactory: {
      Url: ""
    }
  }),
  actions: {
    async DeleteFile(o) {
      if ((await R.executeMethodAsync(
        "fw4.DeleteFile",
        { FileId: o }
      )).Success === !0) return !0;
      throw !1;
    },
    async ShowMessageBox(o, e, t) {
      const n = m(this);
      return new Promise((i) => {
        n.messages.push({
          message: {
            Title: o,
            Content: e,
            Display: !1,
            ButtonList: t.map((c) => ({
              ...c,
              Caption: c.CaptionKey ? p(c.CaptionKey) : c.Caption
            }))
          },
          resolve: i
        }), n.messages.length === 1 && D(this);
      });
    },
    MessageBoxButtonClicked(o) {
      if (!this.MessageBox.Display) return;
      const e = m(this).messages.shift();
      this.MessageBox.Display = !1, e == null || e.resolve(o), queueMicrotask(() => D(this));
    },
    MessageBoxClose() {
      this.MessageBoxButtonClicked("Cancel");
    },
    // Resolves when closed or replaced by another document/report.
    async ShowDocumentStatic(o, e) {
      return C(this), new Promise((t) => {
        m(this).resolveDocument = t, this.DocumentViewer.Url = o, this.DocumentViewer.Title = e, this.DocumentViewer.Display = !0;
      });
    },
    DocumentViewerClose() {
      this.DocumentViewer.Display = !1, this.DocumentViewer.Url = "", C(this);
    },
    // True means the report URL was assigned, not that PDF generation finished.
    async ShowReport(o) {
      C(this);
      const e = m(this).documentVersion;
      this.DocumentViewer.Url = "";
      const t = await R.executeMethodAsync("fw4.ReportPayloadSet", {
        MethodName: o.MethodName,
        Parameters: JSON.stringify(o.Parameters)
      });
      return m(this).documentVersion !== e ? !1 : t.Success === !0 ? (this.DocumentViewer.Title = o.Title, this.DocumentViewer.Display = !0, this.DocumentViewer.Url = "/appinvoke/reporting?" + new URLSearchParams({
        guid: t.ReportGuid,
        fn: o.FileName
      }), !0) : !1;
    },
    // True means the download URL was assigned, not that the download completed.
    async ExportData(o) {
      const e = await R.executeMethodAsync("fw4.ExportPayloadSet", {
        MethodName: o.MethodName,
        Parameters: JSON.stringify(o.Parameters)
      });
      return e.Success === !0 ? (this.ExportFactory.Url = "/appinvoke/export?" + new URLSearchParams({
        guid: e.ExportGuid,
        fn: o.FileName
      }), !0) : !1;
    }
  }
});
class b extends Error {
  constructor(e, t, n) {
    super(`Method "${n}" failed: ${e}`), this.status = e, this.methodId = t, this.methodName = n, this.name = "CommunicationError";
  }
}
class N {
  constructor() {
    s(this, "OnStreamDataReceived");
    s(this, "OnWebSocketConnected");
    s(this, "OnWebSocketDisconnected");
    s(this, "OnWebSocketAuthenticationFailed");
    s(this, "webSocketClient");
    s(this, "methodId");
    s(this, "requestTimeoutMs", 12e4);
    s(this, "ExecutionQueue");
    s(this, "connectWebSockets", () => {
      if (!this.webSocketClient) {
        const e = new j();
        this.webSocketClient = e, e.OnMessageReceived.AddCallback(([t]) => this.webSocketReceive(t, e)), e.OnSocketConnected.AddCallback(this.socketConnected), e.OnSocketDisconnected.AddCallback(() => this.socketDisconnected(e)), e.OnAuthenticationFailed.AddCallback(this.authenticationFailed);
      }
      return this.webSocketClient.connectSocket();
    });
    s(this, "disconnectWebSockets", () => {
      const e = this.webSocketClient;
      e && (e.shouldReconnect = !1, e.disconnectSocket());
    });
    s(this, "executeMethod", (e, t, n, i, c) => {
      var f;
      this.methodId++;
      const r = {
        methodId: this.methodId,
        methodName: e,
        parameters: t,
        receiveDelegate: n,
        errorDelegate: i
      }, a = this.beginRequest(r, c);
      try {
        const d = JSON.stringify({ methodId: r.methodId, methodName: e, parameters: t });
        (f = this.webSocketClient) != null && f.isConnected ? (a.socketClient = this.webSocketClient, a.socketClient.sendMessage(d)) : this.createHttpRequest(a).makeRequest(d);
      } catch {
        this.failRequest(r.methodId, "REQUEST_SEND_FAILED");
      }
    });
    s(this, "executeMethodUpload", (e, t, n, i = {}, c, r) => {
      this.methodId++;
      const a = {
        methodId: this.methodId,
        methodName: n ?? "fileUpload",
        parameters: {},
        receiveDelegate: t,
        errorDelegate: c
      }, f = this.beginRequest(a, r);
      try {
        const d = new FormData();
        Array.from(e).forEach((_) => d.append(_.name, _)), d.append("MethodId", a.methodId.toString()), d.append("MethodName", n ?? ""), d.append("MethodParams", JSON.stringify(i)), this.createHttpRequest(f).makeUpload(d);
      } catch {
        this.failRequest(a.methodId, "REQUEST_SEND_FAILED");
      }
    });
    s(this, "socketConnected", () => {
      this.OnWebSocketConnected.ExecuteSafely();
    });
    s(this, "socketDisconnected", (e) => {
      this.failSocketRequests(e), e === this.webSocketClient && this.OnWebSocketDisconnected.ExecuteSafely();
    });
    s(this, "authenticationFailed", () => {
      const e = this.webSocketClient;
      e && (e.shouldReconnect = !1, e.isConnected = !1, this.failSocketRequests(e, "AUTHTOKEN_INVALID"));
      try {
        e == null || e.disconnectSocket();
      } finally {
        try {
          g().ShowMessageBox(p("fw4.Communication.AuthTitle"), p("fw4.Communication.AuthError"), [
            M[O.OK]
          ]);
        } finally {
          this.OnWebSocketAuthenticationFailed.ExecuteSafely();
        }
      }
    });
    s(this, "blobLoad", (e) => {
      let t = document.createElement("a");
      t.download = e.FileName;
      let n = new Blob([e.Data], { type: e.ContentType }), i = new FileReader();
      i.readAsDataURL(n), i.onload = function() {
        t.href = i.result, t.click();
      };
    });
    s(this, "executeLoadMethod", (e, t) => {
      this.executeMethod(e, t, this.blobLoad);
    });
    s(this, "webSocketReceive", (e, t) => {
      let n;
      try {
        n = this.parseResponseObject(e);
      } catch {
        console.warn("Ignoring malformed WebSocket response.");
        return;
      }
      const i = n.methodId;
      if (typeof i == "number" && Number.isSafeInteger(i) && i > 0) {
        const a = this.ExecutionQueue[i];
        if (!a || a.socketClient !== t) return;
        if (!this.isExecutionResult(n)) {
          this.failRequest(i, "INVALID_RESPONSE");
          return;
        }
        this.executeReceiveDelegate(n);
        return;
      }
      const c = !Object.prototype.hasOwnProperty.call(n, "methodId") || typeof i == "number" && Number.isSafeInteger(i) && i <= 0, r = !Object.prototype.hasOwnProperty.call(n, "errorStatus") || n.errorStatus === "";
      if (!c || !r || !Object.prototype.hasOwnProperty.call(n, "returnObject")) {
        console.warn("Ignoring invalid WebSocket response envelope.");
        return;
      }
      this.OnStreamDataReceived.ExecuteSafely(n.returnObject);
    });
    s(this, "parseResponseObject", (e) => {
      if (typeof e != "string") throw new Error("Expected a text response.");
      const t = JSON.parse(e);
      if (t === null || typeof t != "object" || Array.isArray(t))
        throw new Error("Expected a response object.");
      return t;
    });
    s(this, "isExecutionResult", (e) => typeof e.methodId == "number" && Number.isSafeInteger(e.methodId) && e.methodId > 0 && typeof e.errorStatus == "string" && Object.prototype.hasOwnProperty.call(e, "returnObject"));
    s(this, "getNewMethodId", () => (this.methodId++, this.methodId));
    s(this, "beginRequest", (e, t) => {
      const n = (t == null ? void 0 : t.timeoutMs) ?? this.requestTimeoutMs;
      if (!Number.isFinite(n) || n <= 0 || n > 2147483647)
        throw new RangeError("Request timeout must be a positive number no greater than 2147483647 ms.");
      const i = {
        ...e,
        timeoutHandle: setTimeout(() => this.failRequest(e.methodId, "REQUEST_TIMEOUT"), n)
      };
      return this.ExecutionQueue[e.methodId] = i, i;
    });
    s(this, "createHttpRequest", (e) => {
      const t = new U();
      return e.httpRequest = t, t.OnRequestFailed.AddCallback(([n]) => this.failRequest(e.methodId, n)), t.OnMessageReceived.AddCallback(([n]) => {
        if (!this.ExecutionQueue[e.methodId]) return;
        let i;
        try {
          const c = this.parseResponseObject(n);
          if (!this.isExecutionResult(c) || c.methodId !== e.methodId)
            throw new Error("Invalid response envelope");
          i = c;
        } catch {
          this.failRequest(e.methodId, "INVALID_RESPONSE");
          return;
        }
        this.executeReceiveDelegate(i);
      }), t;
    });
    s(this, "takeRequest", (e) => {
      const t = this.ExecutionQueue[e];
      if (t)
        return delete this.ExecutionQueue[e], clearTimeout(t.timeoutHandle), t;
    });
    s(this, "failRequest", (e, t) => {
      var i, c;
      const n = this.takeRequest(e);
      if (n)
        try {
          (i = n.httpRequest) == null || i.abort();
        } finally {
          (c = n.errorDelegate) == null || c.call(n, new b(t, e, n.methodName));
        }
    });
    s(this, "failSocketRequests", (e, t = "WEBSOCKET_DISCONNECTED") => {
      for (const n of Object.values(this.ExecutionQueue))
        if (n.socketClient === e)
          try {
            this.failRequest(n.methodId, t);
          } catch (i) {
            console.error(i);
          }
    });
    s(this, "executeReceiveDelegate", (e) => {
      var i, c;
      const t = this.takeRequest(e.methodId);
      if (!t) return;
      const n = t.receiveDelegate;
      if (e.errorStatus === "AUTHTOKEN_INVALID") {
        try {
          (i = t.errorDelegate) == null || i.call(t, new b(
            e.errorStatus,
            e.methodId,
            t.methodName
          ));
        } finally {
          this.authenticationFailed();
        }
        return;
      }
      if (e.errorStatus != "") {
        (c = t.errorDelegate) == null || c.call(t, new b(
          e.errorStatus,
          e.methodId,
          t.methodName
        ));
        const r = g();
        switch (e.errorStatus) {
          case "INTERNAL_ERROR":
            r.ShowMessageBox(p("fw4.Communication.ErrorTitle"), p("fw4.Communication.InternalErrorText"), [
              M[O.OK]
            ]);
            break;
        }
      } else n != null && n(e.returnObject);
    });
    this.methodId = 0, this.OnStreamDataReceived = new u(), this.OnWebSocketConnected = new u(), this.OnWebSocketDisconnected = new u(), this.OnWebSocketAuthenticationFailed = new u(), this.webSocketClient = null, this.ExecutionQueue = {};
  }
  static get Instance() {
    return this.singletonInstance || (this.singletonInstance = new this());
  }
  get WebSocketConnected() {
    return this.isWebSocketConnected();
  }
  isWebSocketConnected() {
    var e;
    return ((e = this.webSocketClient) == null ? void 0 : e.isConnected) ?? !1;
  }
  executeMethodAsync(e, t, n) {
    return new Promise((i, c) => {
      this.executeMethod(e, t, (r) => i(r), c, n);
    });
  }
}
s(N, "singletonInstance");
const R = N.Instance, H = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Icon'%3e%3cpath%20id='Vector'%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", K = { class: "dialog__heading" }, $ = { class: "dialog__body" }, Q = ["src"], ne = /* @__PURE__ */ I({
  __name: "DocumentViewer",
  setup(o) {
    const e = g();
    return (t, n) => {
      const i = S("v-btn"), c = S("v-dialog");
      return k(), y(c, {
        persistent: "",
        modelValue: l(e).DocumentViewer.Display,
        class: "dialog-preview"
      }, {
        default: w(() => [
          v(i, {
            class: "btn btn--default-fill btn--round btn--sm ml-auto",
            onClick: n[0] || (n[0] = (r) => l(e).DocumentViewerClose())
          }, {
            default: w(() => [...n[1] || (n[1] = [
              h("img", {
                src: H,
                alt: "Close"
              }, null, -1)
            ])]),
            _: 1
          }),
          h("div", K, E(l(e).DocumentViewer.Title), 1),
          h("div", $, [
            h("iframe", {
              ref: "iframe",
              src: l(e).DocumentViewer.Url,
              frameBorder: "0"
            }, null, 8, Q)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), G = ["src"], se = /* @__PURE__ */ I({
  __name: "ExportFactory",
  setup(o) {
    const e = g();
    return (t, n) => (k(), q("iframe", {
      ref: "export_iframe",
      src: l(e).ExportFactory.Url,
      frameBorder: "0",
      style: { display: "none" }
    }, null, 8, G));
  }
}), J = { class: "dialog__heading" }, Y = ["innerHTML"], z = { class: "dialog__footer" }, oe = /* @__PURE__ */ I({
  __name: "MessageBox",
  setup(o) {
    const e = g();
    return (t, n) => {
      const i = S("v-btn"), c = S("v-dialog");
      return k(), y(c, {
        persistent: "",
        modelValue: l(e).MessageBox.Display
      }, {
        default: w(() => [
          v(i, {
            onClick: n[0] || (n[0] = (r) => l(e).MessageBoxClose()),
            class: "btn btn--default-fill btn--round btn--sm ml-auto"
          }, {
            default: w(() => [...n[1] || (n[1] = [
              h("img", {
                src: H,
                alt: "Close"
              }, null, -1)
            ])]),
            _: 1
          }),
          h("div", J, E(l(e).MessageBox.Title), 1),
          h("div", {
            class: "dialog__body",
            innerHTML: l(e).MessageBox.Content
          }, null, 8, Y),
          n[2] || (n[2] = h("hr", { class: "hr mb-8" }, null, -1)),
          h("div", z, [
            (k(!0), q(V, null, L(l(e).MessageBox.ButtonList, (r, a) => (k(), y(i, {
              flat: "",
              class: W(r.IsPrimary ? "btn btn--primary-fill" : "btn btn--default-fill"),
              onClick: (f) => l(e).MessageBoxButtonClicked(r.Id)
            }, {
              default: w(() => [
                B(E(r.Caption), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))), 256))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
export {
  N as CommunicationClient,
  b as CommunicationError,
  ne as DocumentViewer,
  se as ExportFactory,
  oe as MessageBox,
  O as MessageBoxButtonType,
  M as MessageBoxPredefinedButtons,
  R as commClient,
  te as setTranslator,
  g as useFw4Store
};
//# sourceMappingURL=fw4-library.es.js.map
